import { render, staticRenderFns } from "./FormCreateSlice.vue?vue&type=template&id=ba8d96f4&scoped=true&"
import script from "./FormCreateSlice.vue?vue&type=script&lang=js&"
export * from "./FormCreateSlice.vue?vue&type=script&lang=js&"
import style0 from "./FormCreateSlice.vue?vue&type=style&index=0&id=ba8d96f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8d96f4",
  null
  
)

export default component.exports